import { gsap } from "gsap";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";
import { delay } from "./utils";

gsap.registerPlugin(Draggable, InertiaPlugin);

const createQuestions = () => {
  // get questions
  let questions = gsap.utils.toArray(".js-question");
  if (questions) {
    // navigation
    let currentQuestion = 0;

    // next button
    gsap.utils.toArray(".js-next").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        currentQuestion =
          currentQuestion == questions.length - 1
            ? questions.length - 1
            : currentQuestion + 1;
        displayQuestion(currentQuestion);
      });
    });

    // previous button
    gsap.utils.toArray(".js-prev").forEach((el) => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        currentQuestion = currentQuestion == 0 ? 0 : currentQuestion - 1;
        displayQuestion(currentQuestion);
      });
    });

    // display question
    const displayQuestion = (index) => {
      Array.from(questions).filter((q, i) => {
        q.style.display = i === index ? "block" : "none";
      });
      // update slider percentage
      if (document.querySelector(".js-quizProgress__bar")) {
        index = index == 0 ? 1 : index + 1;
        let value = (100 / 16) * index + "%";
        gsap.to(".js-quizProgress__bar", { width: value });
      }
    };

    // show first question
    displayQuestion(currentQuestion);

    // create questions, draggables etc
    questions.forEach((el) => {
      // get child elems
      let images = el.querySelectorAll(".js-images svg");
      let captions = el.querySelectorAll(".js-captions > div");
      let input = el.querySelector("input");
      let knob = el.querySelector(".knob");
      let bar = el.querySelector(".bar");
      let numbers = el.querySelectorAll(".js-numberButtons > button");

      // function to show the right image and caption on slider value select
      const showAtIndex = (index) => {
        Array.from(images).filter((img, i) => {
          img.style.display = i === index ? "block" : "none";
        });
        Array.from(captions).filter((caption, i) => {
          caption.style.display = i === index ? "block" : "none";
        });
      };

      // init first
      showAtIndex(currentQuestion);

      // init draggable slider
      let interpValue = gsap.utils.interpolate(1, 5);
      let clampValue = gsap.utils.clamp(1, 5);

      // create draggable
      let draggable = new Draggable(knob, {
        type: "x",
        bounds: bar,
        minimumMovement: 6,
        //inertia: true,
        // snap: function (endValue) {
        //   endValue = (Math.round(endValue / 72) * 72).toFixed(0);
        //   return endValue;
        // },
        onDrag: startDragging,
        onDragEnd: stopDragging,
      });

      // call on init
      function startDragging() {
        knob.classList.add('opacity-75');
      }
      function stopDragging() {
        let ratio = this.x / this.maxX;
        input.value = clampValue(interpValue(ratio)).toFixed(0);
        endValue = (Math.round(this.endX / 72) * 72).toFixed(0);
        knob.classList.remove('opacity-75');
        gsap.to(draggable.target, { x: endValue, onUpdate: draggable.update, overwrite: true });
        showAtIndex(input.value - 1);
      }

       // numbers
       numbers.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          let getDistanceToMove = (288 / 100) * btn.dataset.pos;
          gsap.to(draggable.target, {
            x: getDistanceToMove,
            onUpdate: draggable.update,
            overwrite: true,
          });
          input.value = parseInt(btn.textContent);
          showAtIndex(btn.textContent - 1);
        });
      });

    });
  }
};

export { createQuestions };
